import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "shoping-cart-remove",
  "use": "shoping-cart-remove-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"shoping-cart-remove\"><path d=\"M12 4.843l-4.5 4.5M7.5 4.843l4.5 4.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M6.375 22.843a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75zM13.875 22.843a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M.75 7.093l2.329 7.887a1.5 1.5 0 001.45 1.113h10.818A1.5 1.5 0 0016.8 14.98l3.238-12.154a2.249 2.249 0 012.174-1.67h1.038\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/shoping-cart-remove.svg
// module id = qHec
// module chunks = 38 43